import cx from 'classnames';
import React, { ButtonHTMLAttributes } from 'react';
import s from './BButton.module.scss';
import { RippleEffect } from '../lib/components/RippleEffect';

type ButtonVariant = 'text' | 'contained' | 'outlined';
type ButtonSize = 'sm' | 'm';
type ButtonColor = 'primary' | 'secondary' | 'info' | 'warn' | 'error' | 'dark';

export interface BButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  fullWidth?: boolean;
  variant?: ButtonVariant;
  size?: ButtonSize;
  color?: ButtonColor;
  disabled?: boolean;
}

export const BButton = (props: BButtonProps) => {
  const {
    className,
    children,
    disabled,
    size = 'sm',
    variant = 'contained',
    color = 'primary',
    fullWidth = false,
    type = 'button',
    ...otherProps
  } = props;

  const additional = [
    s[size],
    s[color],
    s[variant],
    className,
  ];

  const mods = {
    [s.fullWidth]: fullWidth,
  };

  return (
    <RippleEffect>
      <button
        {...otherProps}
        type={type}
        disabled={disabled}
        className={cx(s.button, mods, additional)}
      >
        {children}
      </button>
    </RippleEffect>
  );
};
